import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7f742cab")

_pushScopeId("data-v-7f742cab")
const _hoisted_1 = { class: "topic-list-item-card" }
const _hoisted_2 = { class: "topic-list-item-card-image" }
const _hoisted_3 = {
  key: 1,
  class: "no-image",
  src: _imports_0
}
const _hoisted_4 = { class: "topic-list-item-card-title" }
const _hoisted_5 = { class: "topic-list-item-card-title-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "topiclist-item",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.recipeImageUrl)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "topic-list-item-card-image-image",
              src: _ctx.recipeImageUrl
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock("img", _hoisted_3))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.removeBr(_ctx.recipeLabel)), 1)
      ])
    ])
  ]))
})